import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { CFilterDropDown, CDropDown } from "@appcues/component-library";

import { selectAccountSegments } from "reducers/account/segments";
import { sortAscending } from "utils";

export class SelectSegmentDropDown extends Component {
  getSegmentsDropdownList() {
    const { segments, blacklist } = this.props;

    return Object.keys(segments).reduce((optionsAcc, segmentId) => {
      if (!blacklist.includes(segmentId)) {
        return [
          ...optionsAcc,
          {
            label:
              segments && segments[segmentId]
                ? segments[segmentId].name
                : segmentId,
            value: segmentId
          }
        ];
      }
      return optionsAcc;
    }, []);
  }

  render() {
    const {
      className,
      placeholder,
      shouldSortSegmentsList,
      useFilterDropDown,
      ...selectProps
    } = this.props;

    const segmentsList = this.getSegmentsDropdownList();
    const segmentsOptionsList = shouldSortSegmentsList
      ? segmentsList.sort((a, b) => {
          const aName = a.label && a.label.toLowerCase();
          const bName = a.label && b.label.toLowerCase();
          return sortAscending(aName, bName);
        })
      : segmentsList;

    const SelectElement = useFilterDropDown ? CFilterDropDown : CDropDown;

    return (
      <SelectElement
        className={classNames("select-segment", className)}
        options={segmentsOptionsList}
        minMenuWidth="260px"
        minWidth="320px"
        indicatorIconClass="fas fa-users"
        placeholder={placeholder}
        {...selectProps}
      />
    );
  }
}

SelectSegmentDropDown.defaultProps = {
  segments: {},
  blacklist: [],
  placeholder: "Choose a segment...",
  shouldSortSegmentsList: false,
  useFilterDropDown: false
};

function mapStateToProps(state) {
  return {
    segments: selectAccountSegments(state)
  };
}

export default connect(mapStateToProps)(SelectSegmentDropDown);
